export default {
	es: {
		enlaces: {
			recetas: '/recetas'
		},
		formulario: {
			email_placeholder: "Introduce tu correo para recibir noticias"
		},
		recetas: {
			dificultad: {
				"0": "Fácil",
				"1": "Media",
				"2": "Dificil"
			}
		},
		textos_categorias_titles: {
			'aperitivos': 'Carretilla - aperitivos con espárragos Carretilla',
			'veganas': 'Carretilla - recetas veganas con espárragos Carretilla',
			'ocasiones-especiales': 'Carretilla - recetas con espárragos Carretilla',
			'cocina-facil': 'Carretilla - recetas fáciles con espárragos Carretilla',
			'en-familia': 'Carretilla - recetas con espárragos Carretilla',
			'ligeras': 'Carretilla - recetas ligeras con espárragos Carretilla',
			'defecto': 'Recetas con espárragos Carretilla'
		},
		textos_categorias_description: {
			'aperitivos': 'Conoce todas los aperitivos que puedes preparar los espárragos Carretilla. ¡Déjate sorprender!',
			'veganas': 'Conoce todas las recetas veganas que puedes preparar con los espárragos Carretilla. ¡Déjate sorprender!',
			'ocasiones-especiales': 'Conoce todas las recetas con espárragos perfectas para las ocasiones especiales. ¡Déjate sorprender!',
			'cocina-facil': 'Conoce como preparar recetas rápidas y fáciles con espárragos Carretilla ¡Déjate sorprender!',
			'en-familia': 'Recetas con espárragos Carretilla para disfrutar en familia. ¡Déjate sorprender!',
			'ligeras': 'Conoce como preparar recetas ligeras con espárragos Carretilla. ¡Déjate sorprender!',
			'defecto': 'Conoce todas las recetas que puedes hacer con los espárragos Carretilla.  Aperitivos, recetas veganas, cocina fácil , para disfrutar en familia…¡descúbrelas!'
		}


	},
	en: {
		enlaces: {
			recetas: "/recipes"
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js